import { defineComponent, onMounted, ref, getCurrentInstance } from "vue";
export default defineComponent({
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var activeIndex = ref("auth");
        onMounted(function() {
            // 根据地址定位活动标签
            activeIndex.value = root.$route.path.substr(root.$route.path.lastIndexOf("/") + 1);
        });
        return {
            activeIndex: activeIndex
        };
    }
});
